webpackJsonp([89101337168390],{

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pageDisclaimerModule = __webpack_require__(730);
	
	var _pageDisclaimerModule2 = _interopRequireDefault(_pageDisclaimerModule);
	
	var _utils = __webpack_require__(56);
	
	var _Blocks = __webpack_require__(93);
	
	var _Blocks2 = _interopRequireDefault(_Blocks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Disclaimer = function Disclaimer(_ref) {
	  var subparts = _ref.pathContext.subparts;
	
	  var _sanitizeContent = (0, _utils.sanitizeContent)(subparts, 'disclaimer'),
	      disclaimer = _sanitizeContent.disclaimer;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _pageDisclaimerModule2.default.wrapper },
	    _react2.default.createElement(_Blocks2.default, { classNames: { cards: _pageDisclaimerModule2.default.content }, headerTag: 'h1', content: disclaimer })
	  );
	};
	
	Disclaimer.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    subparts: _propTypes2.default.array.isRequired
	  })
	};
	
	exports.default = Disclaimer;
	module.exports = exports['default'];

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-templates----page-disclaimer-module---wrapper---3DaqP","content":"src-templates----page-disclaimer-module---content---2bFAH"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-disclaimer-js-f244b29bcad3444f7d8f.js